import BaseModel from './BaseModel';
import { db } from '../utilities';
import { collection, doc, query, where, getDoc, updateDoc, getDocs } from 'firebase/firestore';

export default class Forms extends BaseModel {
  constructor() {
    super(collection(db, 'forms'));
  }

  static async get(id: string) {
    try {
      const docSnap = await getDoc(doc(db, 'forms', id));
      if (docSnap.exists()) {
        return { data: docSnap.data() };
      } else {
        console.error("No such document!");
        return { data: null };
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return { data: null };
    }
  }

  static async updateSharedStatus(id: string, isShared: boolean) {
    try {
      await updateDoc(doc(db, 'forms', id), { shared: isShared });
      return { success: true };
    } catch (error) {
      console.error("Error updating shared status:", error);
      return { success: false, error };
    }
  }

  static async getSharedForms() {
    try {
      const querySnapshot = await getDocs(query(collection(db, 'forms'), where('shared', '==', true)));
      const forms = querySnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      return { data: forms };
    } catch (error) {
      console.error("Error fetching shared forms:", error);
      return { data: [] };
    }
  }
}
